import { createSlice } from "@reduxjs/toolkit";

interface UIState {
  helpPanelOpen: boolean;
}

const initialState: UIState = {
  helpPanelOpen: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openHelpPanel: (state) => {
      state.helpPanelOpen = true;
    },
    closeHelpPanel: (state) => {
      state.helpPanelOpen = false;
    },
    toggleHelpPanel: (state) => {
      state.helpPanelOpen = !state.helpPanelOpen;
    },
  },
});

export const { openHelpPanel, closeHelpPanel, toggleHelpPanel } = uiSlice.actions;
export default uiSlice.reducer;
